<template>
    <v-card elevation="2" class="kpi-card pa-4" :class="{'cursor-pointer': clickable}" @click="$emit('click')">
        <div class="d-flex align-center mb-2">
            <v-avatar :color="color" size="40" variant="tonal">
                <v-icon :color="color">{{ icon }}</v-icon>
            </v-avatar>
            <v-spacer/>
            <v-chip v-if="trend != null" size="x-small" :color="trend >= 0 ? 'green' : 'red'" variant="tonal">
                <v-icon size="12" start>{{ trend >= 0 ? 'mdi-trending-up' : 'mdi-trending-down' }}</v-icon>
                {{ Math.abs(trend) }}%
            </v-chip>
        </div>
        <div class="text-h5 font-weight-bold mb-1">{{ value }}</div>
        <div class="text-caption text-medium-emphasis">{{ title }}</div>
        <div v-if="subtitle" class="text-caption text-medium-emphasis mt-1" style="font-size: 11px !important;">
            {{ subtitle }}
        </div>
        <div v-if="trend != null && trendLabel" class="text-caption" style="font-size: 10px !important;"
             :class="trend >= 0 ? 'text-green' : 'text-red'">
            {{ trend >= 0 ? '+' : '' }}{{ trend }}% {{ trendLabel }}
        </div>
    </v-card>
</template>

<script setup>
defineProps({
    title: {type: String, required: true},
    value: {type: [String, Number], required: true},
    subtitle: {type: String, default: null},
    icon: {type: String, required: true},
    color: {type: String, default: 'primary'},
    trend: {type: Number, default: null},
    trendLabel: {type: String, default: null},
    clickable: {type: Boolean, default: false},
});
defineEmits(['click']);
</script>

<style scoped>
.kpi-card {
    height: 100%;
    transition: all 0.2s ease;
}
.kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}
</style>
